
import MenuModal from "@/components/ui/MenuModal.vue";
import SearchIcon from "@/components/ui/icon/SearchIcon.vue";
import { NavigationLinks } from "../../../fc/Constants/config-navigation";
import SearchWraper from "@/components/ui/SearchWraper.vue";
import NavigationToolList from "~/layouts/partials/navigation/NavigationToolList";

export default {
  name: "NavigationWeb",
  components: {
    Logo: () =>
      import(/* webpackChunkName: "Logo" */ "../../../components/ui/Logo"),
    SearchWraper,
    NavigationLinks: () =>
      import(/* webpackChunkName: "NavigationLinks" */ "./NavigationLinks"),
    NavigationAuth: () =>
      import(/* webpackChunkName: "NavigationAuth" */ "./NavigationAuth"),
    NavigationToolList,
    SearchIcon,
    MenuModal,
  },
  data: () => ({
    previousActiveMenu: "",
  }),
  computed: {
    NavigationLinks() {
      return NavigationLinks(this);
    },
    dashboard() {
      return this.$route.fullPath.includes("/account");
    },
    isTab() {
      return this.$store.state.store.isTab;
    },
    activeMenu() {
      return this.$store.state.activeMenu;
    },
  },
  methods: {
    onOpenMainMenu() {
      this.$refs.searchModal.close();
      this.$store.commit("setActiveMenu", this.previousActiveMenu || 'convert');
    },
    onOpenSearchModal() {
      this.previousActiveMenu = this.activeMenu;
      // close the existing menu modal
      this.closeModal();
      // open the search modal
      this.$refs.searchModal.open();
    },
    onSelectedMenu(activeMenu) {
      this.activeMenu = activeMenu;
    },
    onCloseModal() {
      this.previousActiveMenu = "";
      this.closeModal();
    },
    closeModal() {
      this.$store.commit("setActiveMenu", "");
    },
  },
};
